<script lang="ts" setup>
import type { AddressRetrieve } from '@@/shared/address/types';

const props = withDefaults(defineProps<{
  agentUserName?: string
  variant?: 'lite' | 'full'
  title?: string
}>(), {
  variant: 'lite',
});

const localePath = useLocalePath();
const { locale } = useI18n();
const { m } = useIadFormat();

// Updated address
async function onAddressRetrieveSelect(address?: AddressRetrieve) {
  if (!address) return;
  await navigateTo(localePath({
    name: 'valuation-online-valuation',
    query: {
      addressId: address.id,
      userName: props.agentUserName,
    },
  }, locale.value));
}

const displayContactForm = defineModel<boolean>({ default: false });
watch(displayContactForm, function trackContact(isDialogOpen) {
  if (!isDialogOpen) return;
  trackEvent({
    event: 'agent_interaction',
    event_name: 'click_to_email',
  });
});
</script>

<template>
  <form
    class="pt-xl"
    autocomplete="off"
  >
    <div class="bg-white max-w-3xl mx-auto px-m lg:px-xl py-l rounded-t-2xl">
      <div
        class="flex flex-col gap-s"
        :class="{
          'border-b border-neutral-70': variant === 'full',
        }"
      >
        <ol class="flex gap-s h-[10px]">
          <li class="flex-1 bg-secondary-40 rounded-full" />
          <li class="flex-1 bg-secondary-70 rounded-full" />
          <li class="flex-1 bg-secondary-70 rounded-full" />
        </ol>

        <IadTitle
          tag="h2"
          :text="title"
        />

        <IadInputAddress
          :label="m(`valuation.address_label`)"
          :placeholder="$t(`agent.valuation.address.placeholder`)"
          @update:model-value="onAddressRetrieveSelect"
        />
      </div>

      <div
        v-if="variant === 'full'"
        class="flex flex-col gap-s pt-s"
      >
        <p>
          <span
            class="font-semibold block"
            v-text="$t('valuation.estimate.search_form.question')"
          />
          <span
            class="block"
            v-text="$t('valuation.estimate.search_form.search_nearly_agent')"
          />
        </p>
        <div class="flex justify-center">
          <IadBtn
            variant="link"
            :text="$t('agent.navigation.contact_any_cta')"
            @click="displayContactForm = true"
          />
        </div>
      </div>
    </div>
    <ClientOnly>
      <AgentDialogContactSeller
        id="contact-form-seller"
        v-model="displayContactForm"
      />
    </ClientOnly>
  </form>
</template>
